import React from "react";
import PropTypes from "prop-types";
import BookmarkScroll from "./bookmark-scroll";

export default class BookmarkArrow extends React.Component {
  render() {
    const { bookmark, direction } = this.props;

    return (
      <BookmarkScroll bookmark={bookmark}>
        <a className="arrow" href={`#${bookmark}`}>
          <i className={`fa fa-angle-double-${direction || "down"}`} />
        </a>
      </BookmarkScroll>
    );
  }
}

BookmarkArrow.propTypes = {
  bookmark: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/partials/bookmark-arrow.js